import React from 'react';
import { Row, Col, Form, InputGroup, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSearch } from '@fortawesome/free-solid-svg-icons';
import FilterButtonGroup from 'components/common/FilterButtonGroup';
import { FilterMenu } from 'components/common/FilterButtonGroup';
import { useTranslation } from 'react-i18next';

interface RefundFiltersProps {
  // Search state
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearchKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onClearSearch?: () => void;
  
  // Filter menus
  filterMenus: FilterMenu[];
  
  // Optional components to display inline with filters
  customizeButton?: React.ReactNode;
  actionButtons?: React.ReactNode;
}

const RefundFilters: React.FC<RefundFiltersProps> = ({
  searchTerm,
  onSearchChange,
  onSearchKeyPress,
  onClearSearch,
  filterMenus,
  customizeButton,
  actionButtons
}) => {
  const { t } = useTranslation();
  return (
    <>
      {/* Search and Filter Row */}
      <Row className="g-3 mb-3">
        <Col xs={12} md={6} xl={4}>
          <Form.Group>
            <Form.Label>{t('refunds.searchLabel')}</Form.Label>
            <InputGroup>
              <InputGroup.Text className="bg-transparent">
                <FontAwesomeIcon icon={faSearch} className="text-body-tertiary" />
              </InputGroup.Text>
              <Form.Control
                placeholder={t('refunds.searchPlaceholder')}
                value={searchTerm}
                onChange={onSearchChange}
                onKeyPress={onSearchKeyPress}
              />
              {searchTerm && onClearSearch && (
                <Button 
                  variant="light" 
                  className="border"
                  onClick={onClearSearch}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </Button>
              )}
            </InputGroup>
            <Form.Text className="text-muted">
              {t('refunds.searchHelp')}
            </Form.Text>
          </Form.Group>
        </Col>
        
        {/* Display customize button inline with search */}
        {customizeButton && (
          <Col xs="auto" className="d-flex align-items-center mb-1">
            {customizeButton}
          </Col>
        )}
      </Row>
      
      {/* Filter button group */}
      {filterMenus.length > 0 && (
        <div className="d-flex flex-wrap gap-3 align-items-center mb-3">
          <div className="scrollbar overflow-hidden-y">
            <FilterButtonGroup menus={filterMenus} />
          </div>
        </div>
      )}
      
      {/* Action buttons section */}
      {actionButtons && (
        <div className="d-flex justify-content-end mb-3">
          <div className="d-flex align-items-center">
            {actionButtons}
          </div>
        </div>
      )}
    </>
  );
};

export default RefundFilters;
